import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

import { clsx } from '@/utils/helpers';

export type SectionProps = ComponentProps<'section'> & {
  isFullHeight?: boolean;
};

export function Section({ isFullHeight, className, ...props }: SectionProps) {
  return (
    <section
      className={twMerge(
        'flex w-full items-center justify-center',
        clsx({
          'min-h-screen': isFullHeight,
          'lg:min-h-[calc(100vh-5rem)]': isFullHeight,
        }),
        className,
      )}
      {...props}
    />
  );
}
